export default __webpack_public_path__ + "static/media/image@3x.8a4dfda8.png";